import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Routes,
  Route,
  useNavigate,
  Navigate,
} from "react-router-dom";

import axios from "axios";

import { Login } from "../component/page/login";
import { rutas } from "../rutas/rutas";

import {
  login,
  setInformacion,
  setGeneralNft,
  setEspeciales,
} from "../storage/slices/usuarios";

import { DashboardRouterGame } from "./DashboardRoute";
import { PrivateRouter } from "./PrivateRouter";
import { getCookie } from "../utils/getCookie";

import EcosistemaMundoVirtual from "../logica/EcosistemaMundoVirtual";

export const AppRouter = () => {
  const { usuario } = useSelector(
    (state) => state.userSlice
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const sessionChecked = useRef(false);

  useEffect(() => {
    if (sessionChecked.current) return;

    sessionChecked.current = true;

    const restoreSession = async () => {
      let savedUser = null;

      try {
        savedUser = JSON.parse(
          sessionStorage.getItem("user")
        );
      } catch (error) {
        console.error(
          "Invalid saved user session:",
          error
        );

        sessionStorage.removeItem("user");
        return;
      }

      if (!savedUser?.logged || !savedUser?.user) {
        return;
      }

      const tokenJWT = getCookie("token");

      if (!tokenJWT) {
        sessionStorage.setItem(
          "user",
          JSON.stringify({
            logged: false,
          })
        );

        return;
      }

      dispatch(login(savedUser));

      try {
        const [
          cardsResponse,
          informationResponse,
        ] = await Promise.all([
          axios.get(rutas.getCards, {
            headers: {
              token: tokenJWT,
            },
          }),

          axios.get(rutas.getInformacion, {
            headers: {
              token: tokenJWT,
            },
          }),
        ]);

        dispatch(
          setEspeciales(
            cardsResponse.data?.especiales || []
          )
        );

        dispatch(
          setGeneralNft(
            cardsResponse.data?.generalNft || []
          )
        );

        dispatch(
          setInformacion({
            ...informationResponse.data?.resultado,
          })
        );

        /*
        Si el usuario ya tiene sesión y entra al login,
        lo enviamos directamente al juego.
        */
        const currentPath =
          window.location.pathname;

        const isLoginPage =
          currentPath === "/ecosystem/login" ||
          currentPath.startsWith(
            "/ecosystem/login/"
          ) ||
          currentPath === "/login" ||
          currentPath.startsWith("/login/");

        if (isLoginPage) {
          navigate("/game", {
            replace: true,
          });
        }
      } catch (error) {
        console.error(
          "Session restoration error:",
          error
        );

        sessionStorage.setItem(
          "user",
          JSON.stringify({
            logged: false,
          })
        );

        const currentPath =
          window.location.pathname;

        if (currentPath.startsWith("/game")) {
          navigate("/ecosystem/login", {
            replace: true,
          });
        }
      }
    };

    restoreSession();
  }, [dispatch, navigate]);

  useEffect(() => {
    if (!usuario) return;

    sessionStorage.setItem(
      "user",
      JSON.stringify(usuario)
    );
  }, [usuario]);

  return (
    <Routes>
      {/* ENTRADA PRINCIPAL */}
      <Route
        path="/"
        element={
          <Navigate
            to="/ecosystem"
            replace
          />
        }
      />

      {/* PÁGINA DEL ECOSISTEMA */}
      <Route
        path="/ecosystem"
        element={<EcosistemaMundoVirtual />}
      />

      {/* NUEVO LOGIN OFICIAL */}
      <Route
        path="/ecosystem/login"
        element={<Login />}
      />

      <Route
        path="/ecosystem/login/:ref"
        element={<Login />}
      />

      {/*
      RUTAS ANTIGUAS:
      Las dejamos para que enlaces anteriores
      no se rompan.
      */}
      <Route
        path="/login"
        element={
          <Navigate
            to="/ecosystem/login"
            replace
          />
        }
      />

      <Route
        path="/login/:ref"
        element={<Login />}
      />

      {/* JUEGO PRIVADO */}
      <Route
        path="/game/*"
        element={
          <PrivateRouter>
            <DashboardRouterGame />
          </PrivateRouter>
        }
      />

      {/* DIRECCIONES DESCONOCIDAS */}
      <Route
        path="*"
        element={
          <Navigate
            to="/ecosystem"
            replace
          />
        }
      />
    </Routes>
  );
};